import useSalesNavigatorContracts from "common/datahooks/useSalesNavigatorContracts";

import type { Conversation } from "../types";

export default function useSNConversation(conversation: Conversation) {
  const { salesNavigatorContracts } = useSalesNavigatorContracts(
    conversation?.owner,
  );

  const isSNConversation = conversation?.source === "SALES_NAVIGATOR";

  const hasSNContract =
    salesNavigatorContracts && isSNConversation
      ? !!salesNavigatorContracts.find(
          (contract) => contract.name === conversation.sn_license,
        )
      : false;

  return { isSNConversation, hasSNContract };
}
